import {atom} from "recoil";

/**
 * 에디터에서 작성한 버그 발생 내용
 * @type {RecoilState<String>}
 */
export const bugContents = atom({
    key: "bugContents"
    , default: ""
})